export default {
  5000: "0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8",
  42161: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
  56: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  137: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
  1101: "0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9",
  8453: "0x4200000000000000000000000000000000000006",
  100: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
  59144: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
  1088: "0x0000000000000000000000000000000000000000",
  43114: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
  324: "0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91",
  10: "0x4200000000000000000000000000000000000006",
  169: "0x0Dc808adcE2099A9F62AA87D9670745AbA741746",
  534352: "0x5300000000000000000000000000000000000004",
  81457: "0x4300000000000000000000000000000000000004",
  34443: "0x4200000000000000000000000000000000000006",
  80084: "0x7507c1dc16935b82698e4c63f2746a2fcf994df8",
  80094: "0x6969696969696969696969696969696969696969"
} as { [key: number]: string };
